// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FzDgTPHwjwCv_UFYP2w9 {
    width: 100%;
    font-size: 14px;
}

.FzDgTPHwjwCv_UFYP2w9 thead {
    border-bottom: #E0E0E0 1px solid
}

.FzDgTPHwjwCv_UFYP2w9 thead th {
    padding-bottom: 8px;
    font-size: 13px;
    width: 14.2%;
}

.FzDgTPHwjwCv_UFYP2w9 th:nth-child(3) {
    width: 12%;
}

.FzDgTPHwjwCv_UFYP2w9 th:nth-child(4) {
    width: 8%;
}

.FzDgTPHwjwCv_UFYP2w9 th:nth-child(6) {
    width: 20%;
}

.FzDgTPHwjwCv_UFYP2w9 th:nth-child(7) {
    width: 10.5%;
}

.FzDgTPHwjwCv_UFYP2w9 td {
    line-height: 1.6;
    padding: 13px 10px 11px 0;
    border-bottom: 1px solid #e2dfdf;
}

.FzDgTPHwjwCv_UFYP2w9 th {
    padding-right: 5px;
}

.FzDgTPHwjwCv_UFYP2w9 tfoot td {
    border-bottom: none;
}

/* modal table */
.DMrByRcYhFFBdmXngFs7 {
    width: 1200px;
}

.DMrByRcYhFFBdmXngFs7.FzDgTPHwjwCv_UFYP2w9 th {
    width: initial;
}

/* table select action */

.h9Z5vtjMKijkZ4zpmziI {
    background: #D4E3FF;
    padding: 0 4px;
}

.bnF4We2xyvld6vBy7Nzh {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 5em;
}

.BMmBuLoGMvlH72byalTD {
    display: inline-block;
}

/* override exisitng Bootstrap behavior */
.iTsLMCxgRqoQSwDnLzei.BzoCwjXDKPPks4sOSZk1 .dropdown:hover .dropdown-menu {
    display: none;
}

._4HdhO5495kb0ISapgde {
    text-transform: none;
    font-size: 14px;
    padding: 6px 14px;
    font-weight: 400;
    border-radius: 5px;
}

.RJK9H9ptbg2YO7DdUpOA {
    font-size: 14px;
}

.RJK9H9ptbg2YO7DdUpOA li a {
    padding: 9px 20px;
}

.RHTtUBTw5MZHWoJ1mb6z {
    background-color: #f5fbfc;
}
`, "",{"version":3,"sources":["webpack://./src/pages/duplicates/table.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA,wBAAwB;;AAExB;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,yCAAyC;AACzC;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".table {\n    width: 100%;\n    font-size: 14px;\n}\n\n.table thead {\n    border-bottom: #E0E0E0 1px solid\n}\n\n.table thead th {\n    padding-bottom: 8px;\n    font-size: 13px;\n    width: 14.2%;\n}\n\n.table th:nth-child(3) {\n    width: 12%;\n}\n\n.table th:nth-child(4) {\n    width: 8%;\n}\n\n.table th:nth-child(6) {\n    width: 20%;\n}\n\n.table th:nth-child(7) {\n    width: 10.5%;\n}\n\n.table td {\n    line-height: 1.6;\n    padding: 13px 10px 11px 0;\n    border-bottom: 1px solid #e2dfdf;\n}\n\n.table th {\n    padding-right: 5px;\n}\n\n.table tfoot td {\n    border-bottom: none;\n}\n\n/* modal table */\n.modalTable {\n    width: 1200px;\n}\n\n.modalTable.table th {\n    width: initial;\n}\n\n/* table select action */\n\n.highlight {\n    background: #D4E3FF;\n    padding: 0 4px;\n}\n\n.overflow {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    min-width: 5em;\n}\n\n.keepOverflow {\n    display: inline-block;\n}\n\n/* override exisitng Bootstrap behavior */\n.dropdownContainer.closed :global(.dropdown:hover .dropdown-menu) {\n    display: none;\n}\n\n.dropdownBtn {\n    text-transform: none;\n    font-size: 14px;\n    padding: 6px 14px;\n    font-weight: 400;\n    border-radius: 5px;\n}\n\n.dropdownMenu {\n    font-size: 14px;\n}\n\n.dropdownMenu li a {\n    padding: 9px 20px;\n}\n\n.rowHighlight {\n    background-color: #f5fbfc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `FzDgTPHwjwCv_UFYP2w9`,
	"modalTable": `DMrByRcYhFFBdmXngFs7`,
	"highlight": `h9Z5vtjMKijkZ4zpmziI`,
	"overflow": `bnF4We2xyvld6vBy7Nzh`,
	"keepOverflow": `BMmBuLoGMvlH72byalTD`,
	"dropdownContainer": `iTsLMCxgRqoQSwDnLzei`,
	"closed": `BzoCwjXDKPPks4sOSZk1`,
	"dropdownBtn": `_4HdhO5495kb0ISapgde`,
	"dropdownMenu": `RJK9H9ptbg2YO7DdUpOA`,
	"rowHighlight": `RHTtUBTw5MZHWoJ1mb6z`
};
export default ___CSS_LOADER_EXPORT___;
